module.exports = __webpack_public_path__ + "static/media/mapNodeCluster.50c59e5d.png";